module.exports = __webpack_public_path__ + "static/media/tiles-annualAuditPercentage.5f7edbab.svg";